export default "__VITE_ASSET__Ch3q_ya9__"